const ContentPreviewModal = ({ content, onClose }) => {
    if (!content) return null;

    return (
        <div className="content-modal-overlay" role="presentation" onClick={onClose}>
            <section
                className="content-modal content-preview"
                role="dialog"
                aria-modal="true"
                aria-label="Preview reading content"
                onClick={(event) => event.stopPropagation()}
            >
                <header>
                    <h2>{content.title}</h2>
                    <button type="button" className="content-link-btn" onClick={onClose}>
                        Close
                    </button>
                </header>

                {content.imageUrl && content.imageUrl !== "no-image.jpg" && (
                    <div className="content-preview-cover">
                        <img src={content.imageUrl} alt="" loading="lazy" />
                    </div>
                )}

                <p className="content-preview-meta">
                    {content.author || "ReadWell"} • Level {content.level || "A"} • {content.difficulty || "MEDIUM"}
                </p>

                <p className="content-preview-meta">
                    Categories: {content.categories?.length ? content.categories.join(", ") : "Uncategorized"}
                </p>

                <ol className="content-preview-paragraphs">
                    {content.paragraphs?.map((item) => (
                        <li key={item.id}>{item.paragraph}</li>
                    ))}
                </ol>
            </section>
        </div>
    );
};

export default ContentPreviewModal;
